import PropTypes from 'prop-types';
import { Button, Form } from 'react-bootstrap';
import { useEffect, useRef, useState } from 'react';
import Modal from '../../../../../../../components/Modal';
import CustomToast from '../../../../../../../components/Toast';
import { useCreateTeacherDocumentMutation } from '../../../../../../../features/authentication/teacherDocumentApiSlice';
import { useCreateResourceSetMutation } from '../../../../../../../features/authentication/qSetApiSlice';
import ActivityTypes from '../../../../../../../enums/activityTypes';
import { useNavigate } from 'react-router';
import NewResourceSetNameModal from './newResourceSetNameModal';

const AddDocumentModal = ({ showModal, setShowModal, setId, onUrlAdded }) => {
  const [urlTitle, setUrlTitle] = useState('');
  const [urlContent, setUrlContent] = useState('');
  const [createTeacherDocument, { isLoading: documentIsLoading }] = useCreateTeacherDocumentMutation();
  const [createResourceSet, { isLoading: resourceIsLoading }] = useCreateResourceSetMutation();
  const [showNewSetNameModal, setShowNewSetNameModal] = useState(false);
  const [newSetName, setNewSetName] = useState(urlTitle);
  const navigate = useNavigate();

  useEffect(() => {
    setUrlTitle('');
    setUrlContent('');
  }, [showModal]);

  const handleAddURL = async (isNewSet) => {
    try {
      const result = await createTeacherDocument({
        description: urlTitle,
        isURL: true,
        url: urlContent,
        scope: 0,
        setId: setId
      });
      if (result.error) {
        if (result.error.data.errors)
          CustomToast(result.error.data.errors.Url || result.error.data.errors.Description, 'error');
        else
          CustomToast(result.error.data.error, 'error');
      }
      else {
        CustomToast('Resource Created Successfully.', 'success');
        setShowModal(false);
        if (isNewSet) {
          navigate(`${setId}`)
        } else if (onUrlAdded) {
          onUrlAdded();
        }
      }
    } catch (error) {
      CustomToast('Failed To Create Resource.', 'error');
      console.log(error);
    }
  };

  const handleCreateNewResourceSet = async (e) => {
    e.preventDefault();

    const option = {
      description: newSetName,
      activityType: ActivityTypes.Documents
    };

    try {
      const result = await createResourceSet(option);
      if (result.error) {
        if (result.error.data.errors)
          CustomToast(result.error.data.errors.Description, 'error');
        else
          CustomToast(result.error.data.error, 'error');
      }
      else {
        setId = result.data;
        handleAddURL(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleValidation = (event) => {
    var inputValue = event.target.value;

    if (inputValue.length == 0) {
      event.target.setCustomValidity('');
    } else {
      try {
        new URL(inputValue);
        event.target.setCustomValidity('');
      } catch {
        event.target.setCustomValidity('Please enter a valid URL');
      }

      if (inputValue.length > 255) event.target.setCustomValidity('URL length must not exceed 255 characters!');
    }
  };

  const handleTitleValidation = (event) => {
    var inputValue = event.target.value;

    if (inputValue.length > 50) {
      event.target.setCustomValidity('Title must not exceed 50 characters!');
    } else {
      event.target.setCustomValidity('');
    }
  };

  return (
    <>
      <Modal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        titleName='Add URL'
        contentWidth='50%'>
        <Form className='d-flex flex-column gap-4' onSubmit={(e) => { e.preventDefault(); setId > 0 ? handleAddURL(false) : setShowNewSetNameModal(true) }} >

          <Form.Group id='title' className='w-100'>
            <Form.Label>Title</Form.Label>
            <Form.Control disabled={documentIsLoading || resourceIsLoading} type='text' className='w-100' required defaultValue={urlTitle} onInput={handleTitleValidation} onChange={(e) => setUrlTitle(e.target.value)} />
          </Form.Group>

          <Form.Group id='url' className='w-100'>
            <Form.Label>{'URL (must start with http:// or https://)'}</Form.Label>
            <Form.Control disabled={documentIsLoading || resourceIsLoading} type='url' className='w-100' required defaultValue={urlContent}
              onInput={handleValidation}
              onChange={(e) => setUrlContent(e.target.value)} />
          </Form.Group>

          <div className='d-flex flex-row justify-content-end gap-2 mt-3'>
            <Button style={{ minWidth: '90px' }} variant='castleGray' onClick={() => setShowModal(false)}>Cancel</Button>
            <Button disabled={documentIsLoading || resourceIsLoading} style={{ minWidth: '90px' }} variant='castleRed' type='submit'>{documentIsLoading || resourceIsLoading ? 'Saving...' : 'Save'}</Button>
          </div>
        </Form>
      </Modal>

      <NewResourceSetNameModal
        showModal={showNewSetNameModal}
        setShowModal={setShowNewSetNameModal}
        newSetName={newSetName}
        setNewSetName={setNewSetName}
        handleCreateNewResourceSet={handleCreateNewResourceSet}
      />
    </>
  );
};

AddDocumentModal.propTypes = {
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
  handleSave: PropTypes.func
};

export default AddDocumentModal;